import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import API, { getUploadUrl } from '../../services/api';
import useToast from './useToast';

const CATS  = ['leadership','business','women','healthcare','education','technology'];
const authH = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });
const isDemoMode = () => localStorage.getItem('adminMode') === 'demo';

const EMPTY_FORM = {
  title:'', category:'business', year: new Date().getFullYear(),
  imageUrl:'', slug:'', featured:false, popular:false, order:0, pdfUrl:'',
};

const DEMO_MAGS = [
  { _id:'d1', title:'The Most Innovative Leader in Advanced Clinical Medicine & Surgery – 2026', category:'healthcare', year:2026, featured:true,  popular:true,  order:1, imageUrl:'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=400&h=520&fit=crop&q=80', slug:'clinical-medicine-2026',        pdfUrl:'' },
  { _id:'d2', title:'The Most Impactful HR Strategists to Watch in 2026',                        category:'business',   year:2026, featured:false, popular:true,  order:2, imageUrl:'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=520&fit=crop&q=80', slug:'hr-strategists-2026',          pdfUrl:'' },
  { _id:'d3', title:'The Most Impactful Leader In Education Sector To Watch In 2026',            category:'education',  year:2026, featured:false, popular:true,  order:3, imageUrl:'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=400&h=520&fit=crop&q=80', slug:'education-leader-2026',        pdfUrl:'' },
  { _id:'d4', title:'The Most Influential Global Leader in Strategic Infrastructure Care – 2026', category:'leadership', year:2026, featured:true,  popular:false, order:4, imageUrl:'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=520&fit=crop&q=80', slug:'infrastructure-leader-2026',   pdfUrl:'' },
  { _id:'d5', title:'The Most Empowering Women Leaders To Watch In 2026',                        category:'women',      year:2026, featured:true,  popular:true,  order:5, imageUrl:'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=520&fit=crop&q=80', slug:'empowering-women-2026',        pdfUrl:'' },
  { _id:'d6', title:'The Most Visionary Leader in Strategic Inspirational Leadership – 2026',    category:'leadership', year:2026, featured:false, popular:true,  order:6, imageUrl:'https://images.unsplash.com/photo-1556157382-97eda2f9e2bf?w=400&h=520&fit=crop&q=80', slug:'visionary-leader-2026',        pdfUrl:'' },
  { _id:'d7', title:"The Most Empowering Women Leader – International Women's Day Special 2026", category:'women',      year:2026, featured:false, popular:false, order:7, imageUrl:'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400&h=520&fit=crop&q=80', slug:'womens-day-special-2026',     pdfUrl:'' },
  { _id:'d8', title:'The Most Empowering Women Leader to Watch in 2026',                         category:'women',      year:2026, featured:false, popular:false, order:8, imageUrl:'https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?w=400&h=520&fit=crop&q=80', slug:'empowering-women-leader-2026', pdfUrl:'' },
  { _id:'d9', title:'The Most Influential Planner in Retirement Income Solutions – 2026',        category:'business',   year:2026, featured:false, popular:false, order:9, imageUrl:'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=520&fit=crop&q=80', slug:'retirement-planner-2026',     pdfUrl:'' },
  { _id:'d10',title:'The Most Empowering Woman Leader To Watch In 2026',                         category:'women',      year:2026, featured:false, popular:false, order:10,imageUrl:'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=520&fit=crop&q=80', slug:'empowering-woman-2026',       pdfUrl:'' },
];

const slugify = s => s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');

let demoIdCounter = 100;

export default function AdminMagazines() {
  const [mags,     setMags]     = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [catFilter,setCatFilter]= useState('');
  const [modal,    setModal]    = useState(false);
  const [editing,  setEditing]  = useState(null);
  const [form,     setForm]     = useState(EMPTY_FORM);
  const [saving,   setSaving]   = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [imgTab,   setImgTab]   = useState('url');
  const [pdfTab,   setPdfTab]   = useState('url');
  const [imgPrev,  setImgPrev]  = useState('');
  const [uploads,  setUploads]  = useState([]);
  const [uploading,setUploading]= useState(false);
  const [uploadPct,setUploadPct]= useState(0);
  const imgInputRef = useRef();
  const pdfInputRef = useRef();
  const { addToast, ToastContainer } = useToast();

  /* ── Fetch ── */
  const fetchMags = async () => {
    setLoading(true);
    if (isDemoMode()) {
      setTimeout(() => { setMags([...DEMO_MAGS]); setLoading(false); }, 400);
      return;
    }
    try {
      const r = await API.get('/magazines', { headers: authH() });
      setMags(r.data.data?.length ? r.data.data : [...DEMO_MAGS]);
    } catch { setMags([...DEMO_MAGS]); }
    finally  { setLoading(false); }
  };

  const fetchUploads = async () => {
    if (isDemoMode()) return;
    try {
      const r = await API.get('/upload?type=image', { headers: authH() });
      setUploads(r.data.data || []);
    } catch {}
  };

  useEffect(() => { fetchMags(); }, []);

  /* ── Modal helpers ── */
  const openCreate = () => {
    setEditing(null); setForm(EMPTY_FORM); setImgPrev('');
    setImgTab('url'); setPdfTab('url'); setModal(true); fetchUploads();
  };
  const openEdit = m => {
    setEditing(m);
    setForm({ title:m.title, category:m.category, year:m.year,
      imageUrl:m.imageUrl||'', slug:m.slug, featured:!!m.featured,
      popular:!!m.popular, order:m.order||0, pdfUrl:m.pdfUrl||'' });
    setImgPrev(m.imageUrl||'');
    setImgTab('url'); setPdfTab('url'); setModal(true); fetchUploads();
  };
  const closeModal = () => { setModal(false); setEditing(null); };

  const setF = (k, v) => setForm(f => {
    const n = { ...f, [k]: v };
    if (k === 'title' && !editing) n.slug = slugify(v);
    if (k === 'imageUrl') setImgPrev(v);
    return n;
  });

  /* ── File upload ── */
  const handleFileUpload = async (file, type) => {
    if (!file) return;
    if (isDemoMode()) {
      const fakeUrl = URL.createObjectURL(file);
      if (type === 'image') { setF('imageUrl', fakeUrl); setImgPrev(fakeUrl); }
      else setF('pdfUrl', file.name);
      addToast(`${type === 'image' ? 'Image' : 'PDF'} selected (demo mode)`, 'info');
      return;
    }
    const fd = new FormData();
    fd.append('file', file);
    setUploading(true); setUploadPct(0);
    try {
      const r = await API.post(`/upload/${type}`, fd, {
        headers: { ...authH(), 'Content-Type': 'multipart/form-data' },
        onUploadProgress: e => setUploadPct(Math.round(e.loaded * 100 / e.total)),
      });
      const url = getUploadUrl(r.data.data.url);
      if (type === 'image') { setF('imageUrl', url); setImgPrev(url); }
      else setF('pdfUrl', url);
      addToast(`${type === 'image' ? 'Image' : 'PDF'} uploaded!`, 'success');
      fetchUploads();
    } catch { addToast('Upload failed', 'error'); }
    finally  { setUploading(false); setUploadPct(0); }
  };

  /* ── Save ── */
  const handleSave = async e => {
    e.preventDefault();
    if (!form.title || !form.slug) return addToast('Title and slug are required', 'error');

    /* Demo mode — just mutate local state */
    if (isDemoMode()) {
      setSaving(true);
      await new Promise(r => setTimeout(r, 500));
      if (editing) {
        setMags(prev => prev.map(m => m._id === editing._id ? { ...m, ...form } : m));
        addToast('Magazine updated! (demo)', 'success');
      } else {
        const newMag = { ...form, _id: `demo-${++demoIdCounter}` };
        setMags(prev => [newMag, ...prev]);
        addToast('Magazine created! (demo)', 'success');
      }
      setSaving(false);
      closeModal();
      return;
    }

    setSaving(true);
    try {
      if (editing) {
        await API.put(`/magazines/${editing._id}`, form, { headers: authH() });
        addToast('Magazine updated!', 'success');
      } else {
        await API.post('/magazines', form, { headers: authH() });
        addToast('Magazine created!', 'success');
      }
      closeModal(); fetchMags();
    } catch (err) { addToast(err.response?.data?.message || 'Save failed', 'error'); }
    finally { setSaving(false); }
  };

  /* ── Delete ── */
  const handleDelete = async id => {
    if (!window.confirm('Delete this magazine issue?')) return;
    setDeleting(id);
    if (isDemoMode()) {
      await new Promise(r => setTimeout(r, 400));
      setMags(prev => prev.filter(m => m._id !== id));
      addToast('Deleted (demo)', 'success');
      setDeleting(null);
      return;
    }
    try {
      await API.delete(`/magazines/${id}`, { headers: authH() });
      addToast('Deleted', 'success'); fetchMags();
    } catch { addToast('Delete failed', 'error'); }
    finally  { setDeleting(null); }
  };

  const filtered = mags.filter(m =>
    (!catFilter || m.category === catFilter) &&
    (!search    || m.title.toLowerCase().includes(search.toLowerCase()))
  );

  /* ─────────────────── RENDER ─────────────────── */
  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Magazine Issues</h1>
          <p className="page-subtitle">{mags.length} total issues</p>
        </div>
        <div className="page-actions">
          <button className="btn btn-primary" onClick={openCreate}>+ New Issue</button>
        </div>
      </div>

      <div className="table-card">
        <div className="table-header">
          <span className="table-title">All Issues</span>
          <div className="table-controls">
            <div className="search-box">
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
              </svg>
              <input placeholder="Search issues…" value={search}
                onChange={e => setSearch(e.target.value)}/>
            </div>
            <select className="filter-select" value={catFilter}
              onChange={e => setCatFilter(e.target.value)}>
              <option value="">All Categories</option>
              {CATS.map(c => (
                <option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>
              ))}
            </select>
          </div>
        </div>

        <div style={{ overflowX:'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width:64 }}>Cover</th>
                <th>Title</th>
                <th>Category</th>
                <th>Year</th>
                <th>Flags</th>
                <th>PDF</th>
                <th style={{ width:110, textAlign:'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i}>
                    {[64,300,90,50,120,60,110].map((w, j) => (
                      <td key={j}>
                        <div style={{ height:14, background:'var(--card2)', borderRadius:3,
                          width: j===0 ? 50 : '80%', animation:'pulse 1.4s infinite' }}/>
                      </td>
                    ))}
                  </tr>
                ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={7}>
                    <div className="empty-state">
                      <div className="empty-title">No magazines found</div>
                      <div className="empty-sub">Try a different search or category filter.</div>
                    </div>
                  </td>
                </tr>
              ) : filtered.map(m => (
                <tr key={m._id}>
                  <td>
                    <img src={getUploadUrl(m.imageUrl)} alt=""
                      style={{ width:50, height:50, objectFit:'cover', borderRadius:4,
                        border:'1px solid var(--border-lt)', display:'block' }}
                      onError={e => { e.target.style.display='none'; }}/>
                  </td>
                  <td>
                    <div style={{ fontWeight:500, color:'var(--white)',
                      maxWidth:300, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      {m.title}
                    </div>
                    <div style={{ fontSize:'.72rem', color:'var(--white40)', marginTop:2 }}>
                      /{m.slug}
                    </div>
                  </td>
                  <td><span className="badge badge-gold">{m.category}</span></td>
                  <td style={{ color:'var(--white70)' }}>{m.year}</td>
                  <td>
                    <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                      {m.featured && <span className="badge badge-blue">Featured</span>}
                      {m.popular  && <span className="badge badge-purple">Popular</span>}
                    </div>
                  </td>
                  <td>
                    {m.pdfUrl
                      ? <a href={getUploadUrl(m.pdfUrl)} target="_blank" rel="noopener noreferrer"
                          className="badge badge-red"
                          style={{ textDecoration:'none', cursor:'pointer' }}>PDF ↗</a>
                      : <span style={{ color:'var(--white40)', fontSize:'.75rem' }}>—</span>
                    }
                  </td>
                  <td>
                    <div className="row-actions">
                      <button className="act-edit" title="Edit"
                        onClick={() => openEdit(m)}>✏️</button>
                      <button className="act-delete" title="Delete"
                        disabled={deleting === m._id}
                        onClick={() => handleDelete(m._id)}>
                        {deleting === m._id ? '⏳' : '🗑️'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <span className="pagination-info">
            Showing {filtered.length} of {mags.length} issues
          </span>
        </div>
      </div>

      {/* ─────── MODAL ─────── */}
      {modal && (
        <div className="modal-root">
          <div className="modal-backdrop" onClick={closeModal}/>
          <div className="modal-panel">
            <div className="modal-head">
              <h2>{editing ? 'Edit Magazine Issue' : 'New Magazine Issue'}</h2>
              <button className="modal-close" onClick={closeModal}>✕</button>
            </div>

            <div className="modal-body">
              <form id="mag-form" onSubmit={handleSave}>
                <div className="form-grid">

                  <div className="form-group full">
                    <label className="form-label">Title <span className="req">*</span></label>
                    <input className="form-input" value={form.title} required
                      onChange={e => setF('title', e.target.value)}
                      placeholder="The Most Influential Leader in…"/>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Slug <span className="req">*</span></label>
                    <input className="form-input" value={form.slug} required
                      onChange={e => setF('slug', slugify(e.target.value))}
                      placeholder="auto-generated-from-title"/>
                    <span className="form-hint">URL-friendly identifier</span>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Category</label>
                    <select className="form-select" value={form.category}
                      onChange={e => setF('category', e.target.value)}>
                      {CATS.map(c => (
                        <option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Year</label>
                    <input className="form-input" type="number" value={form.year}
                      min={2020} max={2030}
                      onChange={e => setF('year', +e.target.value)}/>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Sort Order</label>
                    <input className="form-input" type="number" value={form.order}
                      onChange={e => setF('order', +e.target.value)}/>
                  </div>

                  {/* ── Cover Image ── */}
                  <div className="form-group full">
                    <label className="form-label">Cover Image</label>
                    <div className="tabs" style={{ marginBottom:12 }}>
                      {['url','upload','library'].map(t => (
                        <button key={t} type="button"
                          className={`tab-btn${imgTab===t?' active':''}`}
                          onClick={() => { setImgTab(t); if(t==='library') fetchUploads(); }}>
                          {t==='url' ? '🔗 URL' : t==='upload' ? '⬆️ Upload' : '🖼 Library'}
                        </button>
                      ))}
                    </div>

                    {imgTab === 'url' && (
                      <input className="form-input" value={form.imageUrl}
                        onChange={e => setF('imageUrl', e.target.value)}
                        placeholder="https://images.unsplash.com/…"/>
                    )}

                    {imgTab === 'upload' && (
                      <div className="drop-zone"
                        onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
                        onDragLeave={e => e.currentTarget.classList.remove('drag-over')}
                        onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove('drag-over'); handleFileUpload(e.dataTransfer.files[0], 'image'); }}
                        onClick={() => imgInputRef.current?.click()}
                        style={{ cursor:'pointer' }}>
                        <input ref={imgInputRef} type="file" accept="image/*" style={{ display:'none' }}
                          onChange={e => handleFileUpload(e.target.files[0], 'image')}/>
                        <div className="drop-icon">
                          <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#c9a84c" strokeWidth="1.8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                          </svg>
                        </div>
                        <div className="drop-title">Drop image here or <span style={{ color:'var(--gold)', textDecoration:'underline' }}>browse</span></div>
                        <div className="drop-sub">JPEG, PNG, WEBP up to 20 MB</div>
                        {uploading && (
                          <div className="upload-progress" style={{ marginTop:12 }}>
                            <div className="progress-label">
                              <span>Uploading…</span><span>{uploadPct}%</span>
                            </div>
                            <div className="progress-bar-wrap">
                              <div className="progress-bar" style={{ width:`${uploadPct}%` }}/>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {imgTab === 'library' && (
                      <div>
                        {uploads.length === 0 ? (
                          <div className="empty-state" style={{ padding:'24px' }}>
                            <div className="empty-title">No images yet</div>
                            <div className="empty-sub">Upload images first using the Upload tab.</div>
                          </div>
                        ) : (
                          <div className="media-library" style={{ maxHeight:240, overflowY:'auto' }}>
                            {uploads.map(u => (
                              <div key={u._id}
                                className={`media-item${form.imageUrl.includes(u.filename)?' selected':''}`}
                                onClick={() => setF('imageUrl', u.url)}>
                                <img src={getUploadUrl(u.url)} alt={u.originalName}/>
                                <div className="media-check">✓</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {imgPrev && (
                      <div style={{ display:'flex', alignItems:'center', gap:10, marginTop:10 }}>
                        <img src={imgPrev} alt="Preview"
                          style={{ width:56, height:72, objectFit:'cover', borderRadius:4,
                            border:'1px solid var(--border-lt)', display:'block' }}
                          onError={e => e.target.style.display='none'}/>
                        <span style={{ fontSize:'.78rem', color:'var(--white40)' }}>Preview</span>
                        <button type="button" onClick={() => { setF('imageUrl',''); setImgPrev(''); }}
                          style={{ background:'none', border:'none', color:'var(--red)',
                            cursor:'pointer', fontSize:'.78rem' }}>✕ Remove</button>
                      </div>
                    )}
                  </div>

                  {/* ── PDF ── */}
                  <div className="form-group full">
                    <label className="form-label">Magazine PDF <span style={{ color:'var(--white40)', fontWeight:400 }}>(optional)</span></label>
                    <div className="tabs" style={{ marginBottom:12 }}>
                      {['url','upload'].map(t => (
                        <button key={t} type="button"
                          className={`tab-btn${pdfTab===t?' active':''}`}
                          onClick={() => setPdfTab(t)}>
                          {t==='url' ? '🔗 URL' : '⬆️ Upload PDF'}
                        </button>
                      ))}
                    </div>

                    {pdfTab === 'url' && (
                      <input className="form-input" value={form.pdfUrl}
                        onChange={e => setF('pdfUrl', e.target.value)}
                        placeholder="https://example.com/magazine.pdf"/>
                    )}

                    {pdfTab === 'upload' && (
                      <div className="drop-zone"
                        onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
                        onDragLeave={e => e.currentTarget.classList.remove('drag-over')}
                        onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove('drag-over'); handleFileUpload(e.dataTransfer.files[0], 'pdf'); }}
                        onClick={() => pdfInputRef.current?.click()}
                        style={{ cursor:'pointer' }}>
                        <input ref={pdfInputRef} type="file" accept="application/pdf"
                          style={{ display:'none' }}
                          onChange={e => handleFileUpload(e.target.files[0], 'pdf')}/>
                        <div className="drop-icon">
                          <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#c9a84c" strokeWidth="1.8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                          </svg>
                        </div>
                        <div className="drop-title">Drop PDF here or <span style={{ color:'var(--gold)', textDecoration:'underline' }}>browse</span></div>
                        <div className="drop-sub">PDF files up to 20 MB</div>
                        {uploading && (
                          <div className="upload-progress" style={{ marginTop:12 }}>
                            <div className="progress-label"><span>Uploading…</span><span>{uploadPct}%</span></div>
                            <div className="progress-bar-wrap"><div className="progress-bar" style={{ width:`${uploadPct}%` }}/></div>
                          </div>
                        )}
                      </div>
                    )}

                    {form.pdfUrl && (
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:8,
                        padding:'8px 12px', background:'rgba(74,222,128,.08)',
                        border:'1px solid rgba(74,222,128,.2)', borderRadius:4 }}>
                        <span style={{ fontSize:'.82rem', color:'var(--green)' }}>✓ PDF attached:</span>
                        <span style={{ fontSize:'.78rem', color:'var(--white70)', wordBreak:'break-all' }}>
                          {form.pdfUrl.split('/').pop()}
                        </span>
                        <button type="button" onClick={() => setF('pdfUrl','')}
                          style={{ marginLeft:'auto', background:'none', border:'none',
                            color:'var(--red)', cursor:'pointer', fontSize:'.8rem' }}>✕</button>
                      </div>
                    )}
                  </div>

                  {/* Flags */}
                  <div className="form-group">
                    <label className="form-check">
                      <input type="checkbox" checked={form.featured}
                        onChange={e => setF('featured', e.target.checked)}/>
                      <span className="form-check-label">⭐ Featured Issue</span>
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="form-check">
                      <input type="checkbox" checked={form.popular}
                        onChange={e => setF('popular', e.target.checked)}/>
                      <span className="form-check-label">🔥 Popular Issue</span>
                    </label>
                  </div>

                </div>
              </form>
            </div>

            <div className="modal-foot">
              <button className="btn btn-secondary" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" form="mag-form" type="submit" disabled={saving}>
                {saving
                  ? <span style={{ display:'flex', alignItems:'center', gap:6 }}>
                      <span style={{ width:12, height:12, border:'2px solid rgba(13,13,13,.3)',
                        borderTopColor:'var(--bg)', borderRadius:'50%',
                        animation:'spin .7s linear infinite', display:'inline-block' }}/>
                      Saving…
                    </span>
                  : editing ? '✓ Update Issue' : '+ Create Issue'
                }
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{to{transform:rotate(360deg)}} @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
      <ToastContainer/>
    </div>
  );
}
